import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import {
    TimeSeriesInput,
    TimeSeriesMarketWidgetInput,
} from '@clean-code/models';
import { BaseDialog } from '@clean-code/shared/components/ui-confirm';
import { MarketDetailsComponent } from '@clean-code/time-series-identifier/ui-details';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { TranslocoModule } from '@jsverse/transloco';
@Component({
  templateUrl: './market-overview-widget-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogModule,
    FontAwesomeModule,
    TranslocoModule,
    MarketDetailsComponent,
  ],
})
export class MarketOverviewWidgetDialogComponent extends BaseDialog {
  public faTimes = faTimes;
  public datasource: TimeSeriesInput;
  public longName: string;
  constructor(
    dialogRef: MatDialogRef<BaseDialog>,
    @Inject(MAT_DIALOG_DATA)
    public override data: TimeSeriesMarketWidgetInput,
  ) {
    super(dialogRef);

    this.datasource = data.timeSeriesInput;
    this.longName = data.longName;
  }
}
